<ion-content>
  <ion-grid>
    <ion-col sizeSm="6" sizeMd="8">
      <ion-card class="banner-card">
        <ion-card-content>
          <ion-grid>
            <ion-row>
              <ion-col class="ion-text-center">
                <ion-label class="spx-font-weight-600">
                  {{ pageDetails?.title }}
                </ion-label>
              </ion-col>
            </ion-row>
          </ion-grid>
          <form [formGroup]="loginForm" (ngSubmit)="getCustomerByPhone()">
            <ion-row class="ion-padding-start ion-padding-top">
              <ion-col>
                <ion-label class="spx-font-black">
                  Name
                  <span class="spx-color-red">*</span>
                </ion-label>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" class="input-background">
                <input
                  type="text"
                  class="spx-font-16 ion-no-padding full-width"
                  style="background: transparent; outline: none; border: 0"
                  formControlName="name"
                  (keypress)="validateName($event)"
                  name="name"
                />
              </ion-col>
            </ion-row>
            <div
              *ngIf="
                loginForm.controls['name'].invalid &&
                (loginForm.controls['name'].dirty ||
                  loginForm.controls['name'].touched)
              "
              class="spx-color-red"
            >
              <div
                *ngIf="loginForm.controls['name'].errors"
                class="spx-font-14"
              >
                Name is required.
              </div>
            </div>
            <ion-row class="ion-padding-start ion-padding-top">
              <ion-col>
                <ion-label class="spx-font-black">
                  Email
                  <span class="spx-color-red">*</span>
                </ion-label>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" class="input-background">
                <input
                  formControlName="email"
                  class="ion-no-padding full-width"
                  name="email"
                  style="
                    background: transparent;
                    outline: none;
                    border: 0;
                    padding: 0;
                    width: 100%;
                  "
                  type="email"
                  id="ec-mobile-number"
                  aria-describedby="emailHelp"
                />
              </ion-col>
            </ion-row>
            <div
              *ngIf="
                loginForm.controls['email'].invalid &&
                (loginForm.controls['email'].dirty ||
                  loginForm.controls['email'].touched)
              "
              class="spx-color-red"
            >
              <div>
                <ion-label
                  class="spx-color-red spx-font-14"
                  *ngIf="loginForm.controls['email'].hasError('required')"
                >
                  Email is required
                </ion-label>
              </div>
              <div>
                <ion-label
                  class="spx-color-red spx-font-14"
                  *ngIf="loginForm.controls['email'].hasError('pattern')"
                >
                  Please provide a properly formatted email
                </ion-label>
              </div>
            </div>

            <ion-col size="12" *ngIf="errorMessage">
              <div>
                <ion-label class="spx-font-12 spx-color-red">{{
                  errorMessage
                }}</ion-label>
              </div>
            </ion-col>
            <ion-row class="ion-padding-start ion-padding-top">
              <ion-col>
                <ion-label class="spx-font-black">
                  Phone
                  <span class="spx-color-red">*</span>
                </ion-label>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" class="input-background ion-no-padding">
                <div class="form-group">
                  <span class="border-end country-code px-2">
                    <ion-chip class="ion-no-margin" style="max-width: 100px;">
                      <ion-avatar>
                        <img [src]="flag" />
                      </ion-avatar>
                      <ion-label class="spx-font-12">{{ countryCode }}</ion-label>
                    </ion-chip>
                  </span>
                  <input
                    formControlName="phone"
                    type="text"
                    minlength="10"
                    maxlength="10"
                    (keypress)="validateNumber($event)"
                    name="phone"
                    style="
                      background: transparent;
                      outline: none;
                      border: 0;
                      padding: 0;
                      font-size: 12px;
                      width: 100%;
                    "
                    class="form-control full-width"
                    id="ec-mobile-number"
                    aria-describedby="emailHelp"
                    [placeholder]="placeholderString"
                    (change)="getNumber($event)"
                  />
                </div>
              </ion-col>
            </ion-row>
            <div
              *ngIf="
                loginForm.controls['phone'].invalid &&
                (loginForm.controls['phone'].dirty ||
                  loginForm.controls['phone'].touched)
              "
              class="spx-color-red"
            >
              <div
                *ngIf="loginForm.controls['phone'].errors"
                class="spx-font-14"
              >
                Phone number is required.
              </div>
            </div>
            <ion-col size="12" *ngIf="errorMessage">
              <div>
                <ion-label class="spx-font-12 spx-color-red">{{
                  errorMessage
                }}</ion-label>
              </div>
            </ion-col>
            <ion-row>
              <ion-col size="12" class="ion-padding-top">
                <!-- <ion-list class="ion-no-padding"> -->
                <ion-item
                  lines="none"
                  color="white
							  "
                  class="ion-no-padding"
                >
                  <input
                    type="checkbox"
                    class="margin-right-10"
                    formControlName="acceptTerms"
                    name="checkbox"
                  />
                  <ion-label
                    name="acceptTerms"
                    class="spx-font-13 ion-padding-start"
                    >I Accept the
                    <a (click)="showTermsConditions()">terms and conditions</a
                    ><span class="spx-color-red">*</span>
                  </ion-label>
                </ion-item>
                <!-- </ion-list> -->
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col *ngIf="!toggleOtp" class="ion-text-center">
                <ion-button
                  type="submit"
                  [disabled]="!loginForm.valid"
                  color="primary"
                  class="ion-no-margin ion-align-items-center"
                  expand="block"
                  (click)="loginDetailsForm()"
                >
                  <span *ngIf="!submitted && !otpSent">Verify</span>
                  <span *ngIf="!submitted && otpSent">Continue</span>
                  <ion-spinner
                    class="ion-align-items-right"
                    *ngIf="verifyLoader"
                  >
                  </ion-spinner>
                </ion-button>
              </ion-col>

              <ion-col *ngIf="toggleOtp" class="ion-text-center">
                <ion-button
                  type="button"
                  [disabled]="
                    !loginForm.valid ||
                    isFormSubmit ||
                    !loginForm.get('acceptTerms').value
                  "
                  color="primary"
                  class="ion-no-margin ion-align-items-center"
                  expand="block"
                  (click)="getCustomerByPhone()"
                >
                  <span class="primary-text">Continue</span>
                  <ion-spinner
                    class="ion-align-items-right"
                    *ngIf="verifyLoader"
                  >
                  </ion-spinner>
                </ion-button>
              </ion-col>
            </ion-row>
          </form>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-grid>
</ion-content>
